export const ARE_POPUPS_BLOCKED = "axa.arePopupsBloked";

export const setArePopupsBlocked = (arePopupsBlocked) => {
  return {
    type: ARE_POPUPS_BLOCKED,
    payload: arePopupsBlocked
  };
};
